// removed by extract-text-webpack-plugin
module.exports = {"main":"_2kKA2ZHg00dD6DJyM7uQXO","hide":"_3naq8wddlOWaKFIJDeSy4a"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/basic/Float.scss
// module id = 689
// module chunks = 12